"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationAwarePurchaseMotionsAdapter = void 0;

var locationAwarePurchaseMotionsAdapter = function locationAwarePurchaseMotionsAdapter(purchaseMotionData, location, merchandiseId) {
  var purchaseMotionDataByLocation = purchaseMotionData && purchaseMotionData.locations && purchaseMotionData.locations[location];
  var purchaseMotions = purchaseMotionDataByLocation && purchaseMotionDataByLocation.purchaseMotions && purchaseMotionDataByLocation.purchaseMotions[merchandiseId];
  var parsedPurchaseMotions = purchaseMotions ? purchaseMotions.map(function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return obj.key;
  }) : [];
  return parsedPurchaseMotions;
};

exports.locationAwarePurchaseMotionsAdapter = locationAwarePurchaseMotionsAdapter;